import { ErrorPage } from "@components"
import { ReactComponent as PlugSvg } from "@svgs/graphs/plug.svg"
import PropTypes from "prop-types"

const RateLimitedError = ({ code = 429 }) => (
  <ErrorPage
    errorCode={code}
    title="Too Many Requests"
    subTitle="You are making too many requests too quickly. Please wait a minute and try again"
  >
    <PlugSvg />
  </ErrorPage>
)

RateLimitedError.propTypes = {
  code: PropTypes.number,
}

export default RateLimitedError
